import { forgetUsernameReducers } from '@axa-asia/emma-forget-username';
import { iamErrorReducers } from '@axa-asia/emma-iam-error';
import { emmaRegistrationReducers } from '@axa-asia/emma-registration';
import languageReducer from '@axa-asia/hk-shared-utils/lib/languageReducer';
import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import abTestReducer from './modules/abTest';
import contentoReducer from './modules/contento';
import emmaFindMyPolicy from './modules/emma-findMyPolicy';
import emmaForgetPasswordReducer from './modules/emma-forgetPassword';
import emmaRetrieveAccount from './modules/emma-retrieveAccount';
import emmaSignUp from './modules/emma-signup';
import forgetIndividualUsernameReducer from './modules/forgetIndividualUsername';
import forgetPasswordReducer from './modules/forgetPassword';
import forgetUsernameReducer from './modules/forgetUsername';
import loginReducer from './modules/login';
import mainReducer from './modules/main';
import emmaRegistration from './modules/registration';
import signupReducer from './modules/signup';
import signupLifeReducer from './modules/signupLife';
import uiReducer from './modules/ui';

export default combineReducers({
  main: mainReducer,
  abTest: abTestReducer,
  form: formReducer,
  login: loginReducer,
  signup: signupReducer,
  signupLife: signupLifeReducer,
  forgetPassword: forgetPasswordReducer,
  forgetUsername: forgetUsernameReducer,
  forgetIndividualUsername: forgetIndividualUsernameReducer,
  contento: contentoReducer,
  language: languageReducer,
  routing: routerReducer,
  ui: uiReducer,
  emmaForgetPassword: emmaForgetPasswordReducer,
  emmaSignUp,
  emmaFindMyPolicy,
  emmaRegistration,
  emmaRetrieveAccount,
  ...emmaRegistrationReducers,
  ...forgetUsernameReducers,
  ...iamErrorReducers,
});
